module.exports = __webpack_public_path__ + "static/media/MHRP52N0003.f3fcc350.svg";